<div class="h-1.5 rounded-md" [style.background-color]="color()"></div>

<div class="text-xs mt-2 font-medium flex items-center justify-center gap-1">
  @if (phaseLocked()) {
    <i class="pi pi-lock"></i>
  }
  {{ label() }}
</div>
